// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1hzXI","tab":"Tabs_tab__2JjXH","tabActive":"Tabs_tabActive__xkJPz"};